import { Dialog } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useService } from '~/services/service.base';
import { DialogService } from '~/services/service.dialog';
import { CodeVerification } from '~/views/molecules/code.verification';
import { IVerificationCodeDialog } from '~/views/types';

export const VerificationCodeDialog: FC<IVerificationCodeDialog> = observer(
    ({ onSendVerificationCode, onEnterVerificationCode }) => {
        const dialogService = useService(DialogService);
        const { verificationCodeDialogSrv } = dialogService;

        return (
            <Dialog open={verificationCodeDialogSrv.open} className="hr-modal-dialog">
                <div id="sign-in-modal" className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={verificationCodeDialogSrv.handleClose}>
                                <figure>
                                    <img src="/assets/img/modal-close-btn.svg" />
                                </figure>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="modalContent step3">
                                <CodeVerification
                                    onSendVerificationCode={onSendVerificationCode}
                                    onEnterVerificationCode={onEnterVerificationCode}
                                >
                                    We’ve sent a 6-digit code to the email
                                    <br />
                                    linked to your Unity account.
                                </CodeVerification>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    },
);
